<template>
  <div>
    <div class="overlayLoader" v-if="loader">
      <md-progress-spinner
        :md-diameter="100"
        class="md-accent spinner-postion"
        :md-stroke="7"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>
    <div>
      <b-row>
        <div class="md-layout md-gutter">
          <div style="display: flex; margin-left: 20px;">
            <span
              >Vendor Code :
              <span style="font-weight: bold;">{{ vendorId }}</span></span
            >
          </div>
          <div style="display: flex; margin-left: 30px;">
            <span
              >Turnover Status :
              <span style="font-weight: bold;"> {{ status }}</span></span
            >
          </div>
          <div style="display: flex; margin-left: 20px; margin-top: 0px;">
            <span
              >Vendor Name :
              <span style="font-weight: bold;">{{ vendorName }}</span></span
            >
          </div>
          <div class="vendor-meta-row">
            <div class="vendor-meta-item">
              <label class="vendor-meta-label">
                Incorporation Date <span class="required">*</span> :
                <span class="vendor-meta-value" v-if="incorporationDateFlag">
                  {{ incorporationDate }}
                </span>
              </label>
              <div v-if="!incorporationDateFlag" class="vendor-meta-field">
                <date-picker
                  valueType="format"
                  format="DD-MMM-YYYY"
                  placeholder="Incorporation Date"
                  v-model="incorporationDate"
                  :disabled="!editMode"
                ></date-picker>
              </div>
            </div>
            <div class="vendor-meta-item" v-if="buyerRemarks">
              <label class="vendor-meta-label">Remarks:</label>
              <b-form-input
                class="remarks-input"
                v-model="buyerRemarks"
                :title="buyerRemarks"
                disabled
              ></b-form-input>
            </div>
          </div>
          
        </div>
      </b-row>
    </div>
    <div>
      <b-row>
        <b-table
          striped
          style="max-height:400px;"
          hover
          outlined
          :items="turnoverData"
          :fields="turnoverFields"
          show-empty
          class="bg-white"
          sticky-header
        >
          <template #head(turnover_amt)="">
            <div class="mandatory">Turnover/Annum (INR)</div>
          </template>
          <template #head(upload_document)="">
            <div class="mandatory">Documents</div>
          </template>
          <template #cell(turnover_amt)="data">
            <b-form-input
              v-model="data.item.turnover_amt"
              :title="data.item.turnover_amt"
              v-numericOnly
              maxlength="12"
              @blur="checkTurnoverValue(data.item)"
              @keypress="blockDecimal"
              @paste.prevent
              @copy.prevent
              @cut.prevent
              :disabled="!editMode || data.item.is_eligible === false"
            />
            <small class="text-muted">
              Rupees
              <strong> {{ amountInWords(data.item.turnover_amt) }}</strong> only
            </small>
          </template>
          <template #cell(original_file_name)="data">
            <span style="margin-top:1.8rem; cursor:pointer;">
              <a
                v-if="data.item.document_det_id"
                style="cursor:pointer;"
                @click="
                  getOpenKmAuthenticate(
                    data.item.add_info_id,
                    data.item.document_det_id,
                  )
                "
                >{{ data.item.original_file_name }}</a
              >
            </span>
          </template>
          <template #cell(upload_document)="data">
            <md-button
              md-raised
              :class="data.item.dtl_doc_count >= 1 ? 'md-success' : 'md-rose'"
              :disabled="!editMode || !data.item.arch_turn_id || data.item.is_eligible === false"
              @click="
                getOpenKmAuthenticateUploadDocument(data.item.arch_turn_id)
              "
              >Document</md-button
            >
          </template>
          <template #cell(preview)="data">
            <a
              v-if="data.item.original_file_name"
              href="#"
              style="cursor:pointer;"
              @click="
                getOpenKmAuthenticatePreview(
                  data.item.document_det_id,
                  data.item.original_file_name,
                  data.index,
                  turnoverData,
                )
              "
              ><span class="material-icons">
                preview
              </span></a
            >
          </template>
          <template #cell(delete_document)="data">
            <span
              v-if="data.item.original_file_name"
              class="material-icons"
              style="cursor:pointer;"
              @click="getOpenKmAuthenticateDelete(data.item.document_det_id)"
            >
              delete
            </span>
          </template>
          <template #cell(selected)="data">
            <b-form-checkbox
              :value="true"
              :unchecked-value="false"
              v-model="data.item.selected"
              :disabled="!editMode || data.item.is_eligible === false"
              @change="checkUncheckNotApplicable(data.item)"
            ></b-form-checkbox>
          </template>
        </b-table>
      </b-row>
    </div>
    <div>
      <b-row>
        <md-button
          v-if="status === 'DRAFT' || status === 'REJECTED' || status === null"
          :class="editMode ? 'md-warning' : 'md-rose'"
          @click="onOffEditMode()"
          :disabled="editMode"
          >Edit</md-button
        >
        <md-button
          v-if="
            editMode &&
              (status === 'DRAFT' || status === 'REJECTED' || status === null)
          "
          class="md-rose"
          @click="saveTurnover()"
          :disabled="!incorporationDate"
          >Save</md-button
        >
        <md-button
          :disabled="editMode || !incorporationDate"
          v-if="status === 'DRAFT' || status === null"
          class="md-rose"
          @click="checkMandatoryFields()"
          >Submit</md-button
        >
        <md-button
          v-if="status === 'INPROCESS' || status === 'APPROVED'"
          class="md-rose"
          @click="closeTurnoverModal()"
          >Close</md-button
        >
        <md-button
          v-if="status === 'DRAFT' || status === 'REJECTED' || status === null"
          class="md-rose"
          @click="logOutUser"
          >Logout</md-button
        >
         <a
            target="_blank"
            :href="downloadUserManual"
          >
           <md-button 
            size="sm" 
            class="md-rose" 
            @clik="downlaodManual()"
            >User Manual
              </md-button>
          </a>    
      </b-row>
    </div>
    <b-modal
      v-model="showOpenModal"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="xl"
      @hidden="showHideOpenModal(false)"
      title="Preview"
    >
      <previewDoc
        :authToken="authToken"
        :docDtlId="docDtlId"
        :uploadedFileName="uploadedFileName"
        :currentPageIndex="currentPageIndex"
        :data="dynamicData"
      ></previewDoc>
    </b-modal>
    <b-modal
      v-model="showUploadDocumentModal"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="xl"
      title="Upload Document"
      @hidden="showHideUploadDocumentModal(false)"
    >
      <uploadDocument
        :wfHdrId="recordId"
        :openKmAuth="openKmAuth"
        :propMenuId="menuSubmenuAdditionalDetails.menuId"
        :PropSubMenuId="menuSubmenuAdditionalDetails.submenuId"
        :approval_status="status"
        formName="turnoverDocument"
      />
    </b-modal>
    <b-modal
      v-model="showInactiveVendorModal"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      hide-header-close
      size="sm"
      title="Buyer Inactive"
      @hidden="showHideInactiveVendorModal(false, email)"
    >
      <div style="margin-top: 100px; font-weight: bold;">
        Buyer ({{ employeeEmail }}) is inactive, please contact
        <span style="font-weight: bolder; color: red;"
          >(commercial@delhivery.com)</span
        >
      </div>
      <div>
        <md-button class="md-rose" @click="logOutUser">Logout</md-button>
      </div>
    </b-modal>
    <!-- 1.3 (Himanshu) -->
    <b-modal
    modal-class="compact-modal"
      v-model="proceedModal"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      centered
      hide-header-close
      size="sm"
      title="Turnover Declaration"
      @hidden="showHideProceedModal(false, email)"
    >
    <div style="margin-top: 10px;">
      <p style="font-weight: bold;">Please fill your turnover details till {{ deadlineDate }}, ({{ daysLeftBeforeDeadline }} days left)</p>
      <div>
       <md-button class="md-rose" @click="proceedWithoutTurnover('OK')">OK</md-button>
       <md-button class="md-warning" @click="proceedWithoutTurnover('Skip')">Skip</md-button>
      </div>
    </div>
    </b-modal>
  </div>
</template>

<script>
import URL_UTILITY from "../../../utility/url.utility";
import previewDoc from "../PreviewDoc/PreviewDoc.vue";
import commonHelper from "../../../utility/common.helper.utility";
import appStrings from "../../../utility/string.utility";
import uploadDocument from "../../uploadDocument.vue";
import DatePicker from "vue2-datepicker";
export default {
  name: "VendorTurnover",
  components: {
    previewDoc,
    uploadDocument,
    DatePicker,
  },
  data() {
    return {
      loader: false,
      partyName: null,
      status: null,
      vendorName: null,
      turnoverFields: [
        {
          key: "selected",
          label: "Turnover N/A",
          stickyColumn: true,
        },
        {
          key: "financial_year",
          class: "col-fix-small",
          class: "col-small",
        },
        {
          key: "turnover_amt",
          class: "annual-turnover",
        },
        // {
        //   key: "original_file_name",
        //   label: "Documents",
        // },
        // {
        //   key: "preview",
        // },
        // {
        //   key: 'delete_document',
        //   class: 'col-fix-small',
        //   label: 'Delete',
        //   stickyColumn: true
        // },
        {
          key: "upload_document",
        },
      ],
      turnoverData: [],
      partyReqId: null,
      editMode: false,
      downloadDocUrl: URL_UTILITY.getDocumentDownloadUrl,
      isDocumentUploaded: false,
      addInfoId: null,
      openKmAuth: null,
      showOpenModal: false,
      menuSubmenuAdditionalDetails: {
        menuId: null,
        submenuId: null,
      },
      showUploadDocumentModal: false,
      dynamicData: null,
      currentPageIndex: null,
      uploadedFileName: null,
      docDtlId: null,
      authToken: null,
      turnoverId: 0,
      recordId: null,
      vendorId: null,
      recordHeaderId: null,
      proceedModal: false,
      employeeEmail: null,
      employeeId: null,
      headerRecordId: null,
      approvalDetails: [],
      activeBuyer: null,
      showInactiveVendorModal: false,
      incorporationDate: null,
      incorporationDateFlag: false, // 1.3 (Himanshu)
      daysLeftBeforeDeadline: null,
      deadlineDate: null,
      downloadUserManual:URL_UTILITY.downloadTurnOverManualUrl ,
      buyerRemarks:null   
    };
  },
  created() {
    this.eventBus.$on("vendorName", (vendorName) => {
      this.vendorName = vendorName;
    });
  },
  mounted() {
    if (this.$store.state.auth.partyId) {
      this.getName();
    }
    this.setMenuSubmenuId();
    this.partyReqId = JSON.parse(sessionStorage.getItem("partyId"));
    this.vendorId = JSON.parse(sessionStorage.getItem("VendorId"));
    this.getTurnoverData(); 
     setTimeout(() => {
      if(this.isBeforeDeadline === true) {
       this.showHideProceedModal(true);
      }     
    }, 1000) 
  },
  methods: {
    amountInWords(amount) {
      if (!amount || isNaN(amount)) return "";

      const a = [
        "",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
        "Ten",
        "Eleven",
        "Twelve",
        "Thirteen",
        "Fourteen",
        "Fifteen",
        "Sixteen",
        "Seventeen",
        "Eighteen",
        "Nineteen",
      ];
      const b = [
        "",
        "",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
      ];

      const numToWords = (num) => {
        if (num < 20) return a[num];
        if (num < 100)
          return b[Math.floor(num / 10)] + (num % 10 ? " " + a[num % 10] : "");
        if (num < 1000)
          return (
            a[Math.floor(num / 100)] +
            " Hundred" +
            (num % 100 ? " " + numToWords(num % 100) : "")
          );
        if (num < 100000)
          return (
            numToWords(Math.floor(num / 1000)) +
            " Thousand" +
            (num % 1000 ? " " + numToWords(num % 1000) : "")
          );
        if (num < 10000000)
          return (
            numToWords(Math.floor(num / 100000)) +
            " Lakh" +
            (num % 100000 ? " " + numToWords(num % 100000) : "")
          );
        return (
          numToWords(Math.floor(num / 10000000)) +
          " Crore" +
          (num % 10000000 ? " " + numToWords(num % 10000000) : "")
        );
      };

      return `${numToWords(Number(amount))}`;
    },
    getTurnoverData() {
      const payload = {
        partyReqId: this.partyReqId,
      };
      this.loader = true;
      this.$store
        .dispatch("vendor/getTurnoverHistory", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            let result = resp.data.data.turnover_history;
            this.employeeEmail = resp.data.data.employee_email;
            this.employeeId = resp.data.data.employee_id;
            this.activeBuyer = resp.data.data.is_buyer_active;
            if (this.activeBuyer === 0) {
              this.showHideInactiveVendorModal(true, this.employeeEmail);
            }
            this.turnoverData = result;
            for(let i of this.turnoverData) {
              if(i.is_eligible === false) {
                i.selected = true;
                i.turnover_amt = 0;
              }
            }
            this.status = result[0].approval_status;
            this.incorporationDate = resp.data.data.inc_corp_date;
            if (this.incorporationDate) {
              this.incorporationDateFlag = true;
            }
            this.getSavedTurnover();
            if(resp.data.data.turnover_deadline_date) { // 1.3 (Himanshu)
              this.deadlineDate = resp.data.data.turnover_deadline_date;
              const result = this.compareWithDeadline(this.deadlineDate);
              this.isBeforeDeadline = result.isBeforeDeadline;
               if (result.isBeforeDeadline === true) {
                this.daysLeftBeforeDeadline = result.daysLeft;
                 this.showHideProceedModal(false);
               } 
               else {
                sessionStorage.setItem("turnoverModalFlag", true);
                setTimeout(() => {
                this.showHideProceedModal(false);
                }, 1000)
               }
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    onOffEditMode() {
      this.editMode = true;
    },
    getOpenKmAuthenticate(add_info_id, docDtlId) {
      this.addInfoId = add_info_id;
      if (docDtlId) {
        this.isDocumentUploaded = true;
      } else {
        this.isDocumentUploaded = false;
      }
      this.loader = true;
      this.$store
        .dispatch("uploadDocument/getOpenKmAuthenticate")
        .then((response) => {
          this.loader = false;
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            if (!this.isDocumentUploaded) {
              this.addEditAdditionalDetails();
              this.uploadFile();
            } else {
              window.location.href =
                this.downloadDocUrl +
                "/download/" +
                docDtlId +
                "?token=" +
                this.openKmAuth;
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    blockDecimal(e) {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    },
    showHideOpenModal(flag, docDtlId, authToken, fileName) {
      if (flag) {
        this.fileExtension = fileName.split(".").pop();
      }
      if (this.fileExtension === "xlsx") {
        alert("Not Allowed");
      } else {
        this.docDtlId = docDtlId;
        this.authToken = authToken;
        this.uploadedFileName = fileName;
        this.showOpenModal = flag;
      }
    },
    getOpenKmAuthenticatePreview(docDtlId, fileName, index, data) {
      const filterDynamicData = data.filter((a) => a.original_file_name);
      const getFileName = data[index].original_file_name;
      for (let i = 0; i < filterDynamicData.length; i++) {
        if (filterDynamicData[i].original_file_name == getFileName) {
          this.currentPageIndex = i + 1;
          break;
        }
      }
      this.dynamicData = filterDynamicData;
      const extension = commonHelper.getFileExtension(fileName);
      if (extension === "zip") {
        alert("Preview Not Supported this file.");
      } else {
        this.$store.dispatch("shared/setLoader", true);
        this.$store
          .dispatch("uploadDocument/getOpenKmAuthenticate")
          .then((response) => {
            this.$store.dispatch("shared/setLoader", false);
            if (response.status === 200) {
              this.openKmAuth = response.data.data.token;
              if (this.openKmAuth) {
                this.showHideOpenModal(
                  true,
                  docDtlId,
                  this.openKmAuth,
                  fileName,
                );
              }
            }
          })
          .catch(() => {
            this.$store.dispatch("shared/setLoader", false);
          });
      }
    },
    getOpenKmAuthenticateUploadDocument(recordId) {
      this.recordId = recordId;
      this.loader = true;
      this.$store
        .dispatch("uploadDocument/getOpenKmAuthenticate")
        .then((response) => {
          this.loader = false;
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            this.showHideUploadDocumentModal(true);
          } else {
            alert(appStrings.DEPENDENTVSETMSG.DEFAULTMSG);
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    showHideUploadDocumentModal(flag) {
      this.getTurnoverData();
      this.showUploadDocumentModal = flag;
    },
    getOpenKmAuthenticateDelete(docDetailId) {
      this.$store.dispatch("shared/setLoader", true);
      this.$store
        .dispatch("uploadDocument/getOpenKmAuthenticate")
        .then((response) => {
          this.$store.dispatch("shared/setLoader", false);
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            if (this.openKmAuth) {
              this.deleteDocument(docDetailId, this.openKmAuth);
            }
          }
        })
        .catch(() => {
          this.$store.dispatch("shared/setLoader", false);
        });
    },
    deleteDocument(docDetailId, token) {
      const promt = confirm("Are you sure, you want to delete this document?");
      if (promt) {
        const payload = {
          docDetailId: docDetailId,
          token: token,
        };
        this.$store
          .dispatch("vendor/deleteOpenKmDocTurnover ", payload)
          .then((response) => {
            if (response.status === 200) {
              alert("Document Deleted Successfully");
              this.getTurnoverData();
            } else {
              alert(response.response.data.message || "Something went wrong");
            }
          })
          .catch(() => {});
      }
    },
    setMenuSubmenuId() {
      const menuOnboarding = JSON.parse(sessionStorage.getItem("TURNOVER"));
      this.menuSubmenuAdditionalDetails = {
        menuId: menuOnboarding.menu_id,
        submenuId: menuOnboarding.sub_menu_id,
      };
    },
    saveTurnover() {
      let turnoverDetails = [];
      for (let i of this.turnoverData) {
        turnoverDetails.push({
          turnover_amt: +i.turnover_amt,
          party_req_id: this.partyReqId,
          gl_calendar_dtl_id: i.gl_calendar_dtl_id,
          document_det_id: i.document_det_id,
          dtl_record_id: i.dtl_record_id,
          financial_year: i.financial_year,
          not_applicable: i.selected ? true : false,
          arch_turn_id: i.arch_turn_id ? i.arch_turn_id : null,
        });
      }
      const payload = {
        hdr_record_id: this.headerRecordId ? this.headerRecordId : 0,
        employee_email: this.employeeEmail,
        employee_id: this.employeeId,
        vendor_id: this.vendorId,
        party_req_id: this.partyReqId,
        inc_corp_date: this.incorporationDateFlag ? null : this.incorporationDate,
        turnover_dtl: turnoverDetails,
      };
      this.loader = true;
      this.$store
        .dispatch("vendor/addUpdateTurnover", payload)
        .then((response) => {
          this.loader = false;
          if (response.status === 200) {
            this.editMode = false;
            this.getTurnoverData();
          } else {
            alert(response.response.data.message || "Something went wrong");
          }
        })
        .catch(() => {});
    },
    getSavedTurnover() {
      const payload = {
        partyReqId: this.partyReqId,
      };
      this.loader = true;
      this.$store
        .dispatch("vendor/getTurnoverSaved", payload)
        .then((response) => {
          this.loader = false;
          if (response.status === 200) {
            let result = response.data.data.turnover_dtl;
            this.status = response.data.data.approval_status;
            this.headerRecordId = response.data.data.hdr_record_id;
            this.buyerRemarks = response.data.data.buyer_remarks;
            this.turnoverData = result;
            for(let i of this.turnoverData) {
              if(i.is_eligible === false) {
                i.selected = true;
                i.turnover_amt = 0;
              } else {
               i.selected = i.not_applicable;
              }
            }
          } else {
            alert(response.response.data.message || "Something went wrong");
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    closeTurnoverModal() {
      sessionStorage.setItem("turnoverModalFlag", false); // 1.1 (Himanshu)
      this.eventBus.$emit("turnoverModal", false);
    },
    checkTurnoverValue(item) {
      if (!item.selected && item.turnover_amt === "0") {
        alert("Annual Turnover cannot be zero");
        item.turnover_amt = null;
      } else if (item.selected && item.turnover_amt !== "0") {
        alert("For Not Applicable, Annual Turnover must be zero");
        item.turnover_amt = "0";
      }
    },
    checkMandatoryFields() {
      // for (let i of this.turnoverData) {
      //   if (!i.selected && (!i.turnover_amt || i.turnover_amt === "0" || i.turnover_amt === 0)) {
      //     alert(
      //       "Please fill all mandatory fields correctly before submitting."
      //     );
      //     return false;
      //   }
      // }
      for (let i of this.turnoverData) {
        if (!i.selected && (!i.turnover_amt || Number(i.turnover_amt) === 0)) {
          alert(
            "For unselected items, turnover amount must be greater than zero.",
          );
          return false;
        }
        if (i.selected && Number(i.turnover_amt) !== 0) {
          alert("For selected items, turnover amount must be zero.");
          return false;
        }
      }

      this.getDocumentCount();
      return true;
    },
    getDocumentCount() {
      let archIds = [];
      for (let i of this.turnoverData) {
        if (i.arch_turn_id) {
          archIds.push(i.arch_turn_id);
        }
      }
      const payload = {
        inc_corp_date: this.incorporationDate,
        arch_turn_id: archIds,
      };
      this.loader = true;
      this.$store
        .dispatch("vendor/getTurnoverDocumentCount", payload)
        .then((response) => {
          this.loader = false;
          if (response.status === 200) {
            let result = response.data.data;
            const finalResult = result.every(
              (item) => !item.is_eligible || item.doc_exists,
            );
            if (finalResult) {
              this.sendWorkflowProcess();
            } else {
              alert(
                "Submission cannot proceed. Please click on the Edit button and upload the documents for all applicable financial years.", // 1.3 (Himanshu)
              );
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    sendWorkflowProcess() {
      const payload = {
        event_id: 45,
        record_id: this.headerRecordId,
      };
      this.loader = true;
      this.$store
        .dispatch("vendor/sendWorkflowProcess", payload)
        .then((resp) => {
          this.loader = false;
          this.showAlert = true;
          if (resp.status === 200) {
            this.isSuccess = true;
            this.responseMsg = resp.data.message;
            this.approvalDetails = resp.data.data;
            this.sendWorkflowApproval();
          } else {
            alert(resp.data.message);
          }
        })
        .catch(() => {
          this.loader = false;
          alert(resp.data.message);
        });
    },
    sendWorkflowApproval() {
      const payload = {
        event_id: 45,
        record_id: this.headerRecordId,
        approval_details: this.approvalDetails,
      };
      this.loader = true;
      this.$store
        .dispatch("vendor/sendWorkflowApproval", payload)
        .then((resp) => {
          this.loader = false;
          this.showAlert = true;
          if (resp.status === 200) {
            this.isApprovalSent = true;
            this.isSuccess = true;
            this.responseMsg = resp.data.message;
            this.getSavedTurnover();
            alert("Approval Sent Successfully.");
            this.closeTurnoverModal();
          } else {
            alert(resp.data.message);
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    showHideInactiveVendorModal(flag, email) {
      this.showInactiveVendorModal = flag;
      this.employeeEmail = email;
    },
    logOutUser() {
      this.$store.dispatch("logout");
    },
    getName() {
      const payload = {
        party_req_id: this.$store.state.auth.partyId,
      };
      this.loader = true;
      this.$store.dispatch("shared/setLoader", true);
      this.$store
        .dispatch("vendor/getVendorDetails", payload)
        .then((resp) => {
          this.loader = false;
          this.$store.dispatch("shared/setLoader", false);
          if (resp.status === 200) {
            const result = resp.data.data;
            this.vendorName = result.name;
          }
        })
        .catch(() => {
          this.loader = false;
          this.$store.dispatch("shared/setLoader", false);
        });
    },
    checkUncheckNotApplicable(item) {
      if (item.selected) {
        item.turnover_amt = "0";
      }
    },
    showHideProceedModal(flag) { // 1.3 (Himanshu)
      this.proceedModal = flag;
  },
    proceedWithoutTurnover(flag) { // 1.3 (Himanshu)
      if(flag === 'OK') {
        this.proceedModal = false;
      } else {
        this.$emit('close-turnover-modal');
      }
    },
    compareWithDeadline(deadlineStr) {
  if (!deadlineStr || typeof deadlineStr !== "string") {
    alert("Invalid deadline date:", deadlineStr);
    return {
      isBeforeDeadline: false,
      daysLeft: 0
    };
  }
  const toDateObj = (val) => {
    const [day, mon, year] = val.split("-");
    return new Date(`${day} ${mon} ${year}`);
  };
  const today = new Date();
  const systemDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  const deadlineDate = toDateObj(deadlineStr);
  if (isNaN(deadlineDate)) {
    alert("Invalid parsed deadline date");
    return {
      isBeforeDeadline: false,
      daysLeft: 0
    };
  }
  const diffInMs = deadlineDate - systemDate;
  const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
  return {
    isBeforeDeadline: systemDate < deadlineDate,
    daysLeft: diffInDays
  };
}


  },
  beforeDestroy() {
    this.eventBus.$off("vendorName");
    this.eventBus.$off("partyName");
  },
};
</script>
<style>
.col-small > div {
  max-width: 100px;
}
.vendor-meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1.25rem;
  align-items: flex-end;
  margin-left: 10px;
  margin-top: 0.75rem;
}
.vendor-meta-item {
  display: flex;
  flex-direction: row;
  min-width: 200px;
  max-width: 420px;
  margin-top: -8px;
}
.vendor-meta-label {
  font-size: 0.95rem;
  color: #333;
  /* margin-bottom: 0.35rem; */
  font-weight: 500;
}
.vendor-meta-value {
  font-weight: 700;
  margin-left: 0.25rem;
}
.vendor-meta-item .remarks-input,
.vendor-meta-item b-form-input {
  width: 100%;
  margin-top: -5px;
}
.remarks-input {
  min-width: 220px;
}
.required {
  color: #d32f2f;
}
.md-button.md-success {
  background-color: #4caf50 !important;
  color: #fff !important;
}
.custom-modal-body {
  max-height: 30vh;
  overflow-y: auto;
}
.compact-modal .modal-dialog,
.compact-modal .modal-content,
.compact-modal .modal-body {
  min-height: 0 !important;
}
.compact-modal .modal-dialog {
  display: flex !important;
  align-items: center !important;
  min-height: 100vh !important;
  margin: 0 auto !important;
}
.vendor-meta-field{
  margin-top: -5px;
}
</style>
